import React from 'react'

const MainDescription = () => {
    return (
    <>
            <div className="flex">
                {/* design bar start */}
                <div className="flex-shrink-0 hidden lg:block flex-shrink-0 w-16 bg-repeat-y bg-contain " style={{backgroundImage: "url(/images/pattern.svg)"}}></div>
                {/* design bar end */}
                {/* container of actual content start */}
                <div className="flex-grow bg-white">
                    {/* flex start */}
                    <div className="flex flex-wrap px-8 lg:pr-20 py-10">
                        {/* right side of description points start */}
                        <div className="w-full lg:w-3/3 flex flex-wrap lg:flex-nowrap xl:space-x-6">
                                 {/* left side main sub-heading start */}
                                <h3 className="description-heading">
                                    Complete or partial annuloplasty of the mitral and tricuspid valves
                                </h3>
                        {/* left side main sub-heading end */}
                                {/* description start */}
                                <div className="w-full lg:w-3/3 mb-4 lg:mb-0  border-l-8  border-blue-primary px-4">
                                    <p className="description-p">
                                        Enhanced visibility through<sup>1</sup>:
                                    </p>
                                    <ul className = "list-disc pl-5 lg:pr-10 mt-2 description-p">
                                        <li>Translucent low profile holder</li>
                                        <li>Spacing guides to ensure correct suture placement</li>
                                    </ul>
                                </div>
                                {/* description end */}

                                {/* description start */}
                                <div className="w-full lg:w-3/3 mb-4 lg:mb-0 border-l-8  border-blue-primary px-4">
                                <p className="lg:pr-10 description-p">
                                    Easy template removal: <br/>
                                    safe suture release cut points on the template<sup>1,2</sup>
                                </p>
                                </div>
                                {/* description end */}

                            </div>
                        {/* right side of description points end */}
                    </div>
                    {/* flex end */}

                    {/* small code container start */}
                    <p className="px-6 lg:text-right text-base feature-p-text mb-7">
                            CC-MK-00021 A
                        </p>
                    
                    {/* small code container end */}

                </div>
                {/* container of actual content end */}
            </div>
            
            

            {/* blue bar below start */}
            <div className="h-6 bg-red-primary"></div>
            {/* blue bar below end */}
        </>
    )
}

export default MainDescription
